import { isSameUserType } from '../../utils/helperFunction';
import { croTypeNames } from '../../utils/employeeTypes';

// Same CRO check used elsewhere in the portal (ExpenseNavigation.jsx, AssessmentDetails.jsx): role name
// against croTypeNames. UX convenience only - decides who sees the "open my CRO workflow" shortcut.
export const isCro = () => {
  try {
    return isSameUserType({ roleArray: croTypeNames, role: JSON.parse(localStorage.getItem('cred'))?.profile?.role });
  } catch {
    return false;
  }
};

// The CRO's own workflow workspace (Today's tasks list -> per-student stages), mounted at /retention by
// MainRouter on the cro_workflow branch.
export const CRO_WORKFLOW_PATH = '/student-journey/tasks';
